import React from "react";
import { Redirect } from "react-router-dom";

import { Auth } from "./layouts/Auth";
import { Admin } from "./layouts/Admin";
import { Error } from "./layouts/Error";
import { Activation } from "./views/components/Auth/Activation";
import { InvalidToken } from "./views/components/Auth/InvalidToken";
import { ChangePassword } from "./views/components/Auth/ChangePassword";
import { Login } from "./views/components/Auth/Login";
import { ForgotPassword } from "views/components/Auth/ForgotPassword";
import { Dashboard } from "./views/components/Dashboard";
import { Reports } from "./views/components/Reports";
import { AuditLogs } from "./views/components/AuditLogs";
import { UserManagement } from "./views/components/UserManagement/UserList";
import { UserDetails } from "./views/components/UserManagement/UserDetails";
import { TransactionInquiry } from "./views/components/TransactionInquiry";
import { Error401 } from "./views/components/Errors/Error401";
import { Error404 } from "./views/components/Errors/Error404";
import { Error500 } from "./views/components/Errors/Error500";

const routes = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/admin/index" />
  },
  {
    component: Auth,
    routes: [
      {
        path: "/login",
        component: Login,
        layout: "/auth"
      },
      {
        path: "/activation",
        component: Activation,
        layout: "/auth"
      },
      {
        path: "/invalidtoken",
        component: InvalidToken,
        layout: "/auth"
      },
      {
        path: "/changepassword",
        component: ChangePassword,
        layout: "/auth"
      },
      {
        path: "/forgotpassword",
        component: ForgotPassword,
        layout: "/auth"
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    component: Admin,
    routes: [
      {
        path: "/index",
        name: "Dashboard",
        icon: "ni ni-chart-bar-32 text-green",
        component: Dashboard,
        layout: "/admin"
      },
      {
        path: "/reports",
        name: "Reports",
        icon: "ni ni-briefcase-24 text-red",
        component: Reports,
        layout: "/admin"
      },
      {
        path: "/usermanagement",
        name: "User Management",
        icon: "ni ni-badge text-info",
        component: UserManagement,
        layout: "/admin"
      },
      {
        path: "/user/add",
        name: "User Details",
        icon: "ni ni-badge text-info",
        component: UserDetails,
        layout: "/admin"
      },
      {
        path: "/user/:id",
        name: "User Details",
        icon: "ni ni-key-25 text-info",
        component: UserDetails,
        layout: "/admin",
      },
      {
        path: "/transactioninquiry",
        name: "Transaction Inquiry",
        icon: "ni ni-ruler-pencil text-yellow",
        component: TransactionInquiry,
        layout: "/admin"
      },
      {
          path: "/auditlogs",
          name: "Audit Logs",
          icon: "ni ni-books text-green",
          component: AuditLogs,
          layout: "/admin"
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    component: Error,
    routes: [
      {
          path: "/error-401",
          component: Error401,
          layout: "/errors"
      },
      {
          path: "/error-404",
          component: Error404,
          layout: "/errors"
      },
      {
          path: "/error-500",
          component: Error500,
          layout: "/errors"
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
]

export default routes;
